import { CatalogData } from "../../data/catalogData";
import { clientTime } from "../../utilities/index";
import { ChargeData } from "../../data/chargeData";
import { OperationRequestData } from "../../data/operationRequestData";
import { Region } from '../../data/regionsData';
import { Http } from "./http";

/** Запросы к методам получения данных клиента */
export class CatalogApi {
  static async getCatalogAsync(id: number): Promise<CatalogData> {
    const respData = await Http.get(
      `WebClient/GetCatalog?id=${id}&clientTime=${clientTime()}&typeSource=0`
    );
    return new CatalogData(respData?.data);
  }

  static async searchCatalog(
    query: string,
    city: string
  ): Promise<CatalogData> {
    const respData = await Http.get(
      `WebClient/FindServices?queryString=${query}&clientTime=${clientTime()}&city=${
        city ? city : ""
      }&typeSource=0`
    );
    const catData = new CatalogData({
      Id: 0,
      Active: true,
      Type: 0,
      Childrens: respData?.data
    });
    return catData;
  }

  static async searchCatalogExt(
    query: string,
    city: string
  ): Promise<CatalogData> {
    const respData = await Http.get(
      `WebClient/FindOperationsExt?queryString=${query}&clientTime=${clientTime()}&typeSource=0`
    );

    const catData = new CatalogData({
      Id: 0,
      Active: true,
      Type: 0,
      Childrens: []
    });

    if (respData.data.length > 0 && respData.data !== undefined) {
      respData.data.forEach((item: any) => {
        const catalogItem = new CatalogData();
        catalogItem.fillFromRequest(new OperationRequestData(item));
        catData.Childrens.push(catalogItem);
      });
    }
    
    return catData;
  }

  /**
  * Получение списка операций.
  * @returns Список операций.
  */
  public static async findOperationsExt(searchText: string): Promise<CatalogData> {
      const catData = new CatalogData({ Id: 0, Active: true, Type: 0, Childrens: [] })
      let respData = await Http.get(`WebClient/FindOperationsExt?queryString=${searchText}&clientTime=${clientTime()}&typeSource=0`);
      if (respData.data.length > 0 && respData.data !== undefined) {

          respData.data.forEach((item: any) => {
              const catalogItem = new CatalogData();
              catalogItem.fillFromRequest(new OperationRequestData(item));
              catData.Childrens.push(catalogItem);
          });
      }
      return catData;
  }


  /**
  * Получения пакета смс
  */
  static async getRegions(): Promise<Array<Region>> {
    const regions: Array<Region> = [];
    const respData = await Http.get(`Catalog/GetRegions?clientTime=${clientTime()}&typeSource=0`);
    if (respData.data.length > 0 && respData.data !== undefined) {
      respData.data.forEach((item: any) => {
        regions.push(new Region(item));
      });
    }
    return regions;
  }

    /**
  * Получение выставленных счетов.
  * @returns Список документов.
  */
  static async getCharges(isAllChargesVisible: boolean = false): Promise<Array<ChargeData>> {
    const charges: Array<ChargeData> = [];
    let respData = await Http.get(`WebClient/GetCharges?clientTime=${clientTime()}&isAllChargesVisible=${isAllChargesVisible}&typeSource=0`);
    if (respData.data.length > 0 && respData.data !== undefined) {
      respData.data.forEach((item: any) => {
        charges.push(new ChargeData(item));
      });
    }
    return charges;
  }

  static async getBankProducts(): Promise<any> {

    const response = await Http.get(
      `WebClient/GetProducts?clientTime=${clientTime()}&source=0`
    );

    return response;
  }
}
